<template>
  <div>
    <div class="container-fluid m-0 p-0">
      <div class="bgFotoHotel" >
        <div class="overlayHotel">
          <div class="row justify-content-center align-items-center text-center ">
            <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8 center">
               <h3 class="Header__title px-5">
             {{ $t("Gemütliche Zimmer, Familienzimmer oder Hochzeitssuite") }}
            </h3>
            <p class="Header__text">
             {{ $t("Unser Hotel verfügt über 29 Zimmer") }}
              
            </p>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Doppelzimmer -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">{{ $t("Doppelzimmer") }}</h3>
              <p class="willkommen__text">
                {{ $t("In unseren gemütlichen Doppelzimmer übernachten Sie schon") }}
              </p>
              <p>{{ $t("ab") }} 110 € {{ $t("pro Nacht") }}</p>
              <p class="buttonBackground">
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
            <!-- Karussell -->
            <div class="col-lg-3 p-5">
              <img
                src="../assets/doppelzimmer.jpeg"
                class="swiper-slide rundeEcken"
              />
            </div>
          </div>
        </div>
      </section>
      <!-- Einzelzimmer -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">{{ $t("Einzelzimmer") }}</h3>
              <p class="willkommen__text">
                {{ $t("In unseren gemütlichen Einzelzimmer übernachten Sie schon") }}
              </p>
              <p>{{ $t("ab") }} 77 € {{ $t("pro Nacht") }}</p>
              <p class="buttonBackground">
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
            <!-- Karussell -->
            <div class="col-lg-3 p-5">
              <img
                src="../assets/karussellHotel3.jpg"
                class="swiper-slide rundeEcken"
              />
            </div>
          </div>
        </div>
      </section>
      <!-- Familienzimmer -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">{{ $t("Familienzimmer") }}</h3>
              <p class="willkommen__text">
                {{ $t("In unseren gemütlichen Familienzimmer übernachten Sie schon") }}
              </p>
              <p>{{ $t("ab") }} 135 € {{ $t("pro Nacht") }}</p>
              <p class="buttonBackground">
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
            <!-- Karussell -->
            <div class="col-lg-3 p-5">
              <img
                src="../assets/Hotel3.jpg"
                class="swiper-slide rundeEcken"
              />
            </div>
          </div>
        </div>
      </section>
      
      <!-- Familienzimmer -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">{{ $t("Appartments") }}</h3>
              <p class="willkommen__text">
                {{ $t("In unseren geräumigen Appartments übernachten Sie schon") }}
              </p>
              <p>{{ $t("ab") }} 160 € {{ $t("pro Nacht") }}</p>
              <p class="buttonBackground">
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
            <!-- Karussell -->
            <div class="col-lg-3 p-5">
             <img
                src="../assets/HotelAp.jpg"
                class="swiper-slide rundeEcken"
              />
            </div>
          </div>
        </div>
      </section>
      <!-- Hochzeitssuite -->
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              <h3 class="willkommen__title2 pt-5">{{ $t("Hochzeitssuite") }}</h3>
              <p class="willkommen__text">
                {{ $t("In unseren romantischen Hochzeitssuiten übernachten Sie schon") }}
              </p>
              <p>{{ $t("ab") }} 120 € {{ $t("pro Nacht") }}</p>
              <p class="buttonBackground">
                <router-link to="#reservierung" class="btn-reservierung2">
                  <div class="pt-3">{{ $t("Reservieren") }}</div>
                </router-link>
              </p>
            </div>
            <!-- Karussell -->
            <div class="col-lg-3 p-5">
               <img
                src="../assets/HotelHoch.jpg"
                class="swiper-slide rundeEcken"
              />
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="container-fluid" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="col-lg-4 d-flex flex-column align-items-center text-center">
              {{ $t("kurtaxe") }}            
            </div>
          </div>
        </div>
      </section>
      <section>
        <div class="kachelContainer ">
            <div class="card bh1">
              <div class="card-body kachel-body">
                <h5 class="card-title">{{ $t("Rezeption") }}</h5>
              </div>
              <div class="card-footer">
                {{ $t("Wir sind täglich von 6:00 bis 22:00 Uhr für Sie ansprechbar") }}
              </div>
            </div>
            <div class="card bh2">
              <div class="card-body kachel-body">
                <h5 class="card-title">{{ $t("Frühstück") }}</h5>
              </div>
              <div class="card-footer">
                {{ $t("Frühstück wird täglich von 7:00 bis 10:00 Uhr serviert") }}
              </div>
            </div>
            <div class="card bh3">
              <div class="card-body kachel-body">
                <h5 class="card-title">{{ $t("Sauna") }}</h5>
              </div>
              <div class="card-footer">
                {{ $t("Sauna ist täglich von 16:00 bis 22:00 Uhr geöffnet") }}
              </div>
            </div>          
            <div class="card bh4">
              <div class="card-body kachel-body">
                <h5 class="card-title">{{ $t("Solarium") }}</h5>
              </div>
              <div class="card-footer">
                {{ $t("Solarium ist täglich von 8:00 bis 22:00 Uhr geöffnet") }}
              </div>
            </div>          
        </div>
      </section>
      <!-- Reservierungsformular -->
      <section  id="reservierung">
        <div class="container-fluid pb-5" style="background: #f3f3f3">
          <div class="row align-items-center justify-content-center">
            <!-- Text + Button -->
            <div class="willkommen__title2 py-5 col-lg-6 d-flex flex-column align-items-center text-center">
              {{ $t("Reservierungsanfrage") }}
            </div>
          </div>
          <!-- Name -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Name*") }}:</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Name"
                  v-model="mail.name"
                      v-bind:class="background.name"
                />
              </div>
            </div>
          </div>
          <!-- Email -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Email*") }}:</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Email"
                  v-model="mail.email"
                      v-bind:class="background.email"
                />
              </div>
              <p v-if="!isValidEmail && mail.email" class="text-danger">{{ $t("Ungültige E-Mail-Adresse") }}</p>
            </div>
          </div>
          <!-- Telefon -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Telefon") }}:</span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefon"
                  v-model="mail.telefon"
                />
              </div>
            </div>
          </div>
          <!-- DAtum -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Vom") }}*:</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Vom"
                  v-model="mail.von"
                   v-bind:class="background.von"
                />
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <span class="input-group-text mailtext" id="basic-addon1">{{ $t("Bis") }}:</span>
                <input
                  type="date"
                  class="form-control"
                  placeholder="Bis"
                  v-model="mail.bis"
                   v-bind:class="background.bis"
                />
              </div>
            </div>
          </div>

          <!-- Zimmer -->
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.doppelzimmer" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("DoppelzimmerAnzahl") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.einzelzimmer" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("EinzelzimmerAnzahl") }}</span
                >
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.familienzimmer" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("FamilienzimmerAnzahl") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.hochzeitssuite" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1">{{ $t("HochzeitssuiteAnzahl") }}</span>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.appartements" class="form-select mailnumber">
                  <option value="0">0</option>
                  <option value="1">1</option>
                </select>
                <span class="input-group-text mailnumberText" id="basic-addon1"
                  >{{ $t("AppartementsAnzahl") }}</span
                >
              </div>
            </div>
            <div class="col-12 col-lg-3">
              <div class="input-group mb-3">
                <select v-model="mail.verpflegung" class="form-select ">
                  <option value="0">{{ $t("Frühstück") }}</option>
                  <option value="1">{{ $t("Halbpension") }}</option>
                  <option value="2">{{ $t("Vollpension") }}</option>
                  <option value="3">{{ $t("ohne") }}</option>
                </select>
                <span class="input-group-text px-5" id="basic-addon1"
                  >{{ $t("Verpflegung") }}:</span
                >
              </div>
            </div>
            
          </div>

          <div class="row align-items-center justify-content-center">
            <div class="col-12 col-lg-6">
              <div class="mb-3">
                <label for="exampleFormControlTextarea1" class="form-label"
                  >{{ $t("Nachricht") }}:</label
                >
                <textarea
                  class="form-control"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  v-model="mail.message"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  v-model="mail.datenschutz"
                      v-bind:class="background.datenschutz"
                  id="flexCheckDefault"
                />
                <label class="form-check-label" for="flexCheckDefault">
              * {{ $t("Die Angaben zum") }}
                  <router-link to="/Datenschutz" class="">{{
                    $t("Datenschutz")
                  }}</router-link>
                  {{ $t("habe ich gelesen .") }}
                </label>
              </div>
            </div>
          </div>
          <div class="row align-items-center justify-content-center mb-5">
            <div class="col-12 col-lg-6">
              <button type="button" class="btn btn-primary" @click="sendMail()">
                {{ $t("Anfragesenden") }}
              </button>
              </div>
          </div> 
          <div class="row">
            <div class="col-md-12">
              {{ mail.gesendet }}
            </div>
          </div>
        </div>
      </section>
    </div>
    <stickybarTelMail />
  </div>
  <stickyPfeil />
</template>

<script>
//import carouselHeader from "../components/carouselHeader.vue";
import axios from "axios";
import stickybarTelMail from "../components/stickybarTelMail.vue";
import stickyPfeil from "../components/stickyPfeil.vue";

export default {
  name: "MainPage",

  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      newSite: null,
      mail: {
        name: "",
        email: "",
        message: "",
        telefon: "",
        doppelzimmer: 0,
        einzelzimmer: 0,
        familienzimmer: 0,
        hochzeitssuite: 0,
        appartements: 0,
        verpflegung: 0,
        von: "",
        bis: "",
        datenschutz: false,
        gesendet: "",
      },
      background: {
        name: "",
        email: "",
        von: "",
        bis: "",
        message: "",
        datenschutz: "",
      },
    };
  },
  components: {
    stickybarTelMail,
    stickyPfeil,
    //  carouselHeader,
  },
  methods: {
checkEingaben() {
      let re = true;
      if (this.mail.name == "") {
        this.background.name = "border border-2 border-danger";
        re = false;
      } else {
        this.background.name = "border border-2 border-success";
      }
      if (this.mail.email == "") {
        this.background.email = "border border-2 border-danger";
        re = false;
      } else {
        this.background.email = "border border-2 border-success";
      }
      if (this.mail.von == "") {
        this.background.von = "border border-2 border-danger";
        re = false;
      } else {
        this.background.von = "border border-2 border-success";
      }
      if (this.mail.bis == "") {
        this.background.bis = "border border-2 border-danger";
        re = false;
      } else {
        this.background.bis = "border border-2 border-success";
      }
      if (this.mail.datenschutz == false) {
        this.background.datenschutz = "bg-danger";
        re = false;
      } else {
        this.background.datenschutz = "bg-success";
      }

      return re;
    },
    sendMail() {
      if (this.checkEingaben()) {
        const axiosConfig = {
          headers: {
            Accept: "text/plain",
            "Content-Type": "text/plain",
          },
        };
        const payload = {
          //empfaenger: "joerg@pillar.de",
          empfaenger: "info@weinhaus-eberitzsch.de",
          Name: this.mail.name,
          Email: this.mail.email,
          Telefon: this.mail.telefon,
          Text: this.mail.message,
          Doppelzimmer: this.mail.doppelzimmer,
          Einzelzimmer: this.mail.einzelzimmer,
          Familienzimmer: this.mail.familienzimmer,
          Hochzeitssuite: this.mail.hochzeitssuite,
          Appartements: this.mail.appartements,
          Von: this.mail.von,
          Bis: this.mail.bis,          

          Datenschutz: this.mail.datenschutz,
        };
        let mail = this.mail;
        let background = this.background;
        axios
          .post("https://pillar.de/mailrelay/post_attachment.php", payload, axiosConfig)
          .then((response) => {
            console.log("success", response.data);
            mail.gesendet = "Ihre Anfrage wurden erfolgreich versendet";
            mail.name = "";
            background.name = "";
            mail.email = "";
            background.email = "";
            mail.message = "";
            background.message = "";
            mail.datenschutz = false;
            background.datenschutz = "";
            mail.telefon = "";
            background.telefon = "";
            mail.doppelzimmer = 0;
            mail.einzelzimmer = 0;
            mail.familienzimmer = 0;
            mail.hochzeitssuite = 0;
            mail.appartements = 0;
            mail.von = "";
            mail.bis = "";

          })
          .catch((error) => {
            console.log(error.response);
            mail.gesendet =
              "Ihre Kontaktdaten konnten leider nicht gesendet werden. Bitte rufen Sie uns an.";
          });
      }
    },
    toggleDdown() {
      this.visi = true;
      setTimeout(() => (this.visi = false), 2000);
    },

  },
  computed: {
    isValidEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(this.mail.email);
    }
  },
  mounted() {
    window.onresize = () => {
      this.windowHeight = window.innerHeight;
    };
  },
};
</script>

<style scoped></style>
